import { Box, styled, Typography } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { Trans } from 'react-i18next';

import { TextLines } from 'core/elements';
import { NumberHelper } from 'core/helpers';
import { getAgGridTableCellData } from 'core/utils';
import { ICorporatePartConfig } from 'corporate/types';
import { QuotePartColId } from 'quotes/components/QuotePartList';
import { IQuotePart } from 'quotes/types';

const ContentWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
});

const ValueWrapper = styled(Typography)(({ theme }) => ({
  color: theme.palette.neutral[900],
  fontSize: 12,
}));

const PackagingCell = (props: ICellRendererParams) => {
  const data = getAgGridTableCellData(props, QuotePartColId.PACKAGING);

  if (!data) {
    return props?.value;
  }

  const corporatePartConfig = (data as IQuotePart)?.corporatePartConfig as ICorporatePartConfig;

  const contentWrapper = <ContentWrapper />;
  const valueWrapper = <ValueWrapper />;

  const packValue = (
    <Trans
      i18nKey="labelPackWithValue"
      components={{ contentWrapper, valueWrapper }}
      values={{
        value: NumberHelper.formatIntegerPerUom(
          corporatePartConfig?.packageUnits,
          corporatePartConfig?.uom
        ),
      }}
    />
  );

  const moqValue = (
    <Trans
      i18nKey="labelMoqWithValue"
      components={{ contentWrapper, valueWrapper }}
      values={{
        value: NumberHelper.formatIntegerPerUom(
          corporatePartConfig?.minimumQuantity,
          corporatePartConfig?.uom
        ),
      }}
    />
  );

  const incrValue = (
    <Trans
      i18nKey="labelIncrWithValue"
      components={{ contentWrapper, valueWrapper }}
      values={{
        value: NumberHelper.formatIntegerPerUom(
          corporatePartConfig?.orderIncrement,
          corporatePartConfig?.uom
        ),
      }}
    />
  );

  return <TextLines texts={[packValue, moqValue, incrValue]} isSubText />;
};

export default PackagingCell;
